"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "liberi": {
    "49367da0": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "skipSearch": false
    }],
    "cerreta": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8ad9444a": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "skipSearch": false
    }],
    "fusaro": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a9180f4": [{
      "hkey": "0e6a3d6b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "liberi": [{
      "hkey": "0e6a3d6b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "244aa8b1": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "skipSearch": false
    }],
    "merangeli": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35e84312": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "skipSearch": false
    }],
    "san-paolo": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e2fe97a": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "skipSearch": false
    }],
    "valle-satrulo": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae6f88fe": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "a0ca6782",
      "slug": "liberi",
      "name": "Liberi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;